import React from "react";

import styles from "./CheckBox.module.scss";

const CheckBox = ({ label, name, value, onChange, isChecked }) => {
  return (
    <div className={styles.checkbox}>
      <input
        type="checkbox"
        className={styles.custom_checkbox}
        checked={isChecked}
        value={value}
        onChange={(e) =>
          onChange({
            checked: e.target.checked,
            value: e.target.value,
          })
        }
      />
      <label>{label}</label>
    </div>
  );
};

export default CheckBox;
